import { PaymentConfigCategory } from '../../models/paymentConfig';
import client from '../httpclient';

function getExpenseCategories(
  protocolId: string,
  categoryId: string,
  subcategoryId: string,
): Promise<PaymentConfigCategory[]> {
  return client.get(
    `/re/v1/protocol/${protocolId}/paymentCategory/${categoryId}/paymentSubcategory/${
      subcategoryId}/expenseCategory`,
  );
}

export default getExpenseCategories;
